const jazzSubgenres = [
  // Traditional and Classic Styles
  "New Orleans Jazz",
  "Dixieland",
  "Traditional Jazz",
  "Stride Jazz",
  "Swing",
  "Bebop",
  "Cool Jazz",
  "Hard Bop",
  "West Coast Jazz",
  "Kansas City Jazz",
  "Modal Jazz",
  "Post-Bop",
  "Free Jazz",
  "Avant-Garde Jazz",
  "Contemporary Jazz",
  "Mainstream Jazz",

  // Big Band and Orchestral
  "Big Band",
  "Big Band Swing",
  "Contemporary Big Band",
  "Orchestral Jazz",
  "Symphonic Jazz",
  "Brass Band Jazz",
  "Chamber Jazz",
  "Third Stream",
  "Modern Creative",

  // Vocal Jazz
  "Vocalese",
  "Scat",
  "Contemporary Vocal Jazz",
  "Spoken Word Jazz",

  // Fusion and Modern Styles
  "Jazz Fusion",
  "Jazz-Funk",
  "Jazz-Rock",
  "Smooth Jazz",
  "Acid Jazz",
  "Nu Jazz",
  "Electro Swing",
  "Jazztronica",
  "Future Jazz",
  "Jazz Noir",

  // World Music Fusion
  "Latin Jazz",
  "Afro-Cuban Jazz",
  "Bossa Nova",
  "Ethio-Jazz",
  "Indo-Jazz",
  "Ethno Jazz",
  "Mediterranean Jazz",
  "Balkan Jazz",
  "Cape Verdean Jazz",
  "Afrobeat Jazz",

  // European Jazz Styles
  "Gypsy Jazz",
  "Manouche Jazz",
  "Flamenco Jazz",
  "Celtic Jazz",
  "Klezmer Jazz",
  "ECM Style",
  "Nordic Jazz",
  "Scandinavian Jazz",
  "British Jazz",
  "Continental Jazz",
  "European Free Jazz",
  "French Touch Jazz",
  "Dutch Improv",
  "Italian Jazz Prog",

  // Soul, R&B and Pop Influenced
  "Soul Jazz",
  "Neo-Soul",
  "R&B Jazz",
  "Urban Jazz",
  "Future Soul",
  "Quiet Storm Jazz",
  "Pop Jazz",

  // Hip-Hop Influenced
  "Jazz Rap",
  "Hip-Hop Jazz",
  "Trip Hop Jazz",
  "Lo-Fi Jazz",

  // Electronic and Dance Influenced
  "Broken Beat",
  "Acid House Jazz",
  "Jazz House",
  "Drum 'n' Bass Jazz",
  "Techno Jazz",
  "Electro-Improvisation",

  // Experimental and Avant-Garde
  "M-Base",
  "Punk Jazz",
  "Jazz Metal",
  "Math Jazz",
  "Crossover Jazz",
  "Prog Jazz",
  "Micro-Jazz",
  "Post-Jazz",
  "Post-Fusion",
  "Post-Modern Jazz",
  "Skronk Jazz",
  "No Wave",
  "Free Improvisation",
  "Spiritual Jazz",
  "Afrofuturist Jazz",

  // Contemporary Classical Influenced
  "Neo-Classical Jazz",
  "New Complexity Jazz",
  "Spectral Jazz",
  "Folktronica Jazz",
  "Post-Rock Jazz",

  // Ambient and Minimalist
  "Minimal Jazz",
  "Ambient Jazz",
  "Drone Jazz",

  // Narrative, Literary and Conceptual
  "Cinematic Jazz",
  "Narrative Jazz",
  "Literary Jazz",
  "Beat Jazz",

  // Family and Community
  "Family Jazz",

  // General Experimental
  "Noise",
  "Glitch",
  "Ambient",
  "Drone",
  "Microtonal",
  "Just Intonation",
  "Atonal",
  "Serialism",
  "Aleatoric",
  "Minimalism",
  "Post-Minimalism",
  "Spectralism",
  "Musique Concrete",
  "Electroacoustic",
  "Acousmatic",
  "Sound Art",
  "Sound Poetry",
  "Field Recording",
  "Phonography",
  "Circuit Bending",
  "Process Music",
  "Spatial Music",
  "Soundscape Composition",
  "Lowercase",
  "Generative Music",
  "Noise Wall",
  "Live Coding",
  "Transidiomatic Improvisation",
  "Fluxus",
  "Industrial",
  "Art Punk",
  "Post-Punk",
  "Noisecore",
  "Power Electronics",
  "Harsh Noise",
  "Dark Ambient",

  // Improvisational
  "Ambient Improvisation",
  "Ambient Folk Jazz",
  "Transcultural Improvisation",
  "Text-Sound Composition",
  "Micro-Improvisation",
  "Algorithmic Improv",

  // Other
  "Other",
];

export default jazzSubgenres;

// Most recognised/common genres — surfaced first in dropdowns and pickers
export const popularJazzSubgenres = [
  "Swing",
  "Bebop",
  "Cool Jazz",
  "Hard Bop",
  "Modal Jazz",
  "Free Jazz",
  "Post-Bop",
  "Avant-Garde Jazz",
  "Contemporary Jazz",
  "Jazz Fusion",
  "Jazz-Funk",
  "Jazz-Rock",
  "Smooth Jazz",
  "Latin Jazz",
  "Bossa Nova",
  "Afro-Cuban Jazz",
  "Soul Jazz",
  "Big Band",
  "Gypsy Jazz",
  "Spiritual Jazz",
];

// Full list with popular genres sorted to the top — use this as the options
// source for grouped displays (Autocomplete groupBy, Select subheaders).
// The default export order is preserved for any existing consumers.
export const jazzSubgenresGrouped = [
  ...popularJazzSubgenres,
  ...jazzSubgenres.filter((g) => !popularJazzSubgenres.includes(g)),
];
